import { useQuery } from "@tanstack/react-query";
import fileService from "api/fileService";
import useToken from "components/hooks/useToken";
import { solicitudes } from "api/solicitudes";

const fetchResumenCuotasUrl = async (
  solicitudId: number,
  token: string
): Promise<string> => {
  const { resumenPath } = await solicitudes(
    token
  ).postGenerateResumenCuotasConsumo(solicitudId);

  const fileName = resumenPath.replace("consumo/", "");
  const fileServicePath = fileService(token, "consumo");

  const response = await fileServicePath.download(
    encodeURIComponent(fileName.toLowerCase()).replace(/%2520/g, "%20")
  );

  if (response) {
    return response.url;
  } else {
    throw new Error("No se pudo descargar el resumen de cuotas!");
  }
};

export const useResumenCuotas = (solicitudId: number, enabled: boolean) => {
  const token = useToken();

  return useQuery(
    ["resumenCuotasUrl", solicitudId],
    () => fetchResumenCuotasUrl(solicitudId, token),
    {
      enabled,
      retry: false,
      refetchOnWindowFocus: false,
      onError: (error) => {
        console.error("Error fetching resumen URL:", error);
      },
    }
  );
};
